var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hiprint-design__wrapper"},[_c('div',{attrs:{"id":"hiprint-design"}})])
}]

export { render, staticRenderFns }